import { render, staticRenderFns } from "./SubscriptionsPredict.vue?vue&type=template&id=40cb0561&scoped=true&"
import script from "./SubscriptionsPredict.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsPredict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cb0561",
  null
  
)

export default component.exports